import { render } from "./SwitchToggle.vue?vue&type=template&id=4164a8a6&scoped=true"
import script from "./SwitchToggle.vue?vue&type=script&lang=js"
export * from "./SwitchToggle.vue?vue&type=script&lang=js"

import "./SwitchToggle.vue?vue&type=style&index=0&id=4164a8a6&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4164a8a6"],['__file',"resources/js/components/admin/components/SwitchToggle.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4164a8a6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4164a8a6', __exports__)) {
    api.reload('4164a8a6', __exports__)
  }
  
  module.hot.accept("./SwitchToggle.vue?vue&type=template&id=4164a8a6&scoped=true", () => {
    api.rerender('4164a8a6', render)
  })

}


export default __exports__